import { render, staticRenderFns } from "./ProfileAttention.vue?vue&type=template&id=0190ccb2&scoped=true&"
import script from "./ProfileAttention.vue?vue&type=script&lang=js&"
export * from "./ProfileAttention.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAttention.vue?vue&type=style&index=0&id=0190ccb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0190ccb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0190ccb2', component.options)
    } else {
      api.reload('0190ccb2', component.options)
    }
    module.hot.accept("./ProfileAttention.vue?vue&type=template&id=0190ccb2&scoped=true&", function () {
      api.rerender('0190ccb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/attention/ProfileAttention.vue"
export default component.exports